/** The geometry of one tab the ink needs — a subset of `HTMLElement`. */
export interface InkTabBox {
    readonly offsetLeft: number;
    readonly offsetWidth: number;
}

/** The inline style of the sliding ink bar. */
export interface InkStyle {
    width: string;
    transform: string;
    transition: string;
}

/** The ink's easing, `.32s` spring (P/grant-finder.html:1205-1215, EASE). */
const InkTransition = 'transform .32s cubic-bezier(.2,.7,.2,1), width .32s cubic-bezier(.2,.7,.2,1)';

/**
 * Where the ink bar sits for the active tab (P/grant-finder.html:1205-1215):
 * the active tab's width and left offset. The first paint and reduced motion
 * both snap (`transition: none`) instead of sliding in from nowhere.
 */
export function MeasureInk(tabs: ReadonlyArray<InkTabBox>, activeIndex: number, firstPaint: boolean, reducedMotion: boolean): InkStyle {
    const active = tabs[activeIndex];
    if (active === undefined) {
        return { width: '0px', transform: 'translateX(0px)', transition: 'none' };
    }
    return {
        width: `${active.offsetWidth}px`,
        transform: `translateX(${active.offsetLeft}px)`,
        transition: firstPaint || reducedMotion ? 'none' : InkTransition,
    };
}
